import { PROCESS_NAME } from '../transactions/transactionProcessWaitlist';

const isWaitlistProcess = (processName) => {
  return processName === PROCESS_NAME;
};

export default isWaitlistProcess;
